<template>
  <div :class="classes">
    <pt-form-item label="类型" :required="true" :labelWidth="labelWidth">
      <detection-category-chinese-selector v-model="form.type" name="type" v-validate="'required'" data-vv-as="类型" placeholder="请输入中文名称"></detection-category-chinese-selector>
    </pt-form-item>
    <div v-for="(level1, index) in form.contents" :key="index">
		<!-- <p style="margin:0"><el-button type="text" @click="insert(index)">插入一级模块</el-button></p> -->
		<pt-form-item label="一级标题" :labelWidth="labelWidth" :required="true">
			<el-input v-model="level1.header" placeholder="请输入一级标题"></el-input>
			<!-- <el-button type="text" @click="cancelInsert(index)">删除一级模块</el-button> -->
		</pt-form-item>
		<div v-for="(level2, index_sec) in level1.contents" :key="index_sec">
			<p style="margin:0"><el-button type="text" @click="insertLevel2(index,index_sec)">插入二级标题</el-button></p>
      <pt-form-item label="二级标题" :labelWidth="labelWidth">
        <el-input v-model.trim="level2.header" placeholder="请选择二级标题"></el-input>
        <el-button type="text" class="deleteBtn" @click="cancelInsertLevel2(index,index_sec)">删除二级标题</el-button>
      </pt-form-item>
      <pt-form-item label="有无图标" :labelWidth="labelWidth">

        <wt-upload-file :action="uploadApi" :data="picture_params"
            v-model="level2.imgURL" :img-url="privateResourcesUrl" :multiple="false">
               <i class="el-icon-circle-plus avatar-uploader-icon upload-plus"></i>
            </wt-upload-file>

      </pt-form-item>
			<div v-for="(level3, index_third) in level2.contents" :key="index_third">
				<p style="margin:0"><el-button type="text" @click="insertLevel3(index,index_sec,index_third)">插入三级标题</el-button></p>
				<pt-form-item label="三级标题" :labelWidth="labelWidth">
					<!-- 图标select -->
					<el-input v-model.trim="level3.header" placeholder="请选择三级标题"></el-input>
					<el-button class="deleteBtn" type="text" @click="cancelInsertLevel3(index,index_sec,index_third)">删除三级标题</el-button>
				</pt-form-item>
				<!-- <pt-form-item label="有无图标" :labelWidth="labelWidth">
					<el-radio class="radio" v-model="level3.hasIcon" :label='true'>是</el-radio>
          <el-radio class="radio" v-model="level3.hasIcon" :label='false'>否</el-radio>
				</pt-form-item> -->
			</div>
			<!-- <p :style="{paddingLeft:'100px'}">
				<el-button icon="el-icon-plus" size="mini" type="primary" class="addBtn" @click="addLevel3(index,index_sec)">添加三级标题</el-button>
			</p> -->
		</div>
		<pt-form-item label="" :labelWidth="labelWidth">
			<el-button icon="el-icon-plus" size="mini" type="primary" class="addBtn" @click="addLevel2(index)">添加二级标题</el-button>
			<!-- <el-button type="primary" v-if="index==form.contents.length-1" class="addBtn" @click="addLevel1(index)">添加一级标题</el-button> -->
		</pt-form-item>
	</div>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import detectionCategoryChineseSelector from 'cps/gene-product/selector/detection-category-chinese-selector'
// 组件class前缀
const prefixCls = 'pt-detection-corpus-structure-form'

export default {
  name: 'pt-detection-corpus-structure-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    detectionCategoryChineseSelector
  },
  data () {
    return {
      feildList: [{ name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }, { name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }],
      uploadApi: this.$uploadApi,
      privateResourcesUrl: this.$privateResourcesUrl,
      picture_params: {
        resourceName: 'headerimage',
        objectId: '标题图标'
      },
      labelWidth: '90px',
      form: JSON.stringify(this.value) !== '{}' ? this.value : {
        contents: [{
          header: '',
          contents: []
        }],
        type: ''
      }
    }
  },
  watch: {
    form: {
      handler: function (val) {
        this.$emit('input', val)
      },
      deep: true
    },
    value: {
      handler: function (val) {
        this.form = val
      },
      deep: true
    }
  },
  methods: {
    // 插入一条一级模块
    // insert (index) {
    //   this.form.contents.splice(index, 0, { header: '', contents: [] })
    //   console.log(this.form.contents)
    // },
    // cancelInsert (index) {
    //   if (index === 0 && this.form.contents.length === 1) {
    //     this.$message.error('不能再删除了')
    //     return
    //   }
    //   this.$confirm('确定要删除该模块?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.form.contents.splice(index, 1)
    //   })
    // },
    insertLevel2 (index, indexSec) {
      var level1 = this.form.contents[index]
      level1.contents.splice(indexSec, 0, { header: '', contents: [] })
    },
    cancelInsertLevel2 (index, indexSec) {
      var level1 = this.form.contents[index]
      this.$confirm('确定要删除该模块?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        level1.contents.splice(indexSec, 1)
      })
    },
    insertLevel3 (index, indexSec, indexThird) {
      var level2 = this.form.contents[index].contents[indexSec]
      level2.contents.splice(indexThird, 0, { header: '' })
    },
    cancelInsertLevel3 (index, indexSec, indexThird) {
      var level2 = this.form.contents[index].contents[indexSec]
      this.$confirm('确定要删除该模块?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        level2.contents.splice(indexThird, 1)
      })
    },
    // 添加一级标题
    // addLevel1 (index) {
    //   if (this.form.contents[this.form.contents.length - 1].header === '') {
    //     this.$message.error('请填写一级标题')
    //     return
    //   }
    //   var level2 = this.form.contents[index].contents
    //   // 判断最后一个二级标题是否填写
    //   if (level2.length) {
    //     if (level2[level2.length - 1].header === '') {
    //       this.$message.error('请填写二级标题')
    //       return
    //     }
    //     // 判断最近的一个三级标题是否为空
    //     var level3 = level2[level2.length - 1].contents
    //     if (level3.length && level3[level3.length - 1].header === '') {
    //       this.$message.error('请填写三级标题')
    //       return
    //     }
    //   }
    //   this.form.contents.push({ header: '', contents: [] })
    // },
    // 取消添加一级标题
    // cancelAddLevel1 () {
    //   this.form.contents.splice(this.form.contents.length - 1, 1)
    // },
    // 添加二级标题
    addLevel2 (index) {
      var level1 = this.form.contents[index]
      if (level1.header === '') {
        this.$message.error('请填写一级标题')
        return
      }
      if (level1.contents.length) {
        // 判断最近的一个二级标题是否为空
        if (level1.contents[level1.contents.length - 1].header === '') {
          this.$message.error('请填写二级标题')
          return
        }
        // 判断最近的一个三级标题是否为空
        var level3 = level1.contents[level1.contents.length - 1].contents
        if (level3.length && level3[level3.length - 1].header === '') {
          this.$message.error('请填写三级标题')
          return
        }
      }
      level1.contents.push({ header: '', contents: [], imgURL: '' })
    },
    // 取消添加二级标题
    cancelAddLevel2 (index) {
      var level2 = this.form.contents[index].contents
      level2.splice(level2.length - 1, 1)
    },
    // 添加三级标题
    addLevel3 (index, indexSec) {
      var level2 = this.form.contents[index].contents[indexSec]
      if (level2.header === '') {
        this.$message.error('请填写二级标题')
      } else {
        // 判断最近的一个三级标题是否为空
        if (level2.contents[level2.contents.length - 1] && level2.contents[level2.contents.length - 1].header === '') {
          this.$message.error('请填写三级标题')
          return
        }
        level2.contents.push({ header: '' })
      }
    },
    // 取消添加三级标题
    cancelAddLevel3 (index, indexSec) {
      var level3 = this.form.contents[index].contents[indexSec].contents
      level3.splice(level3.length - 1, 1)
    }

  }
}
</script>

<style  lang="less">
@import "~less/var.less";
.pt-detection-corpus-structure-form{
  margin-bottom: 20px;
  .el-select,.el-input{
    max-width: 280px;
  }
  .wt-selector{
    width: 100%;
  }
  .preview-avatar{
    width:50px;
    vertical-align: middle;
    margin-right: 20px;
  }
  .upload-plus{
    color:@mainColor;
    font-size: 30px;
    vertical-align: middle;
  }
  .deleteBtn{
    margin-left: 20px;
  }
  .el-upload--picture-card{
    background-color: transparent;
    border: none;
    width:50px;
    height: 50px;
    line-height: 50px;
  }
  .el-upload-list--picture-card .el-upload-list__item{
    width:50px;
    height: 50px;
    line-height: 50px;
    border-radius: 50%;
  }
}
</style>
